import defaultReducer from "./defaultReducer";

export default defaultReducer("VIEW_COMMENTS_MODAL", { open: false });
